<template>
  <div class="relative">
    <div class="btn-resource-add">
      <v-btn
        large
        depressed
        max-height="32px"
        color="#fecd06"
        class="button-type-1"
        @click.stop="appendResource"
      >
        <v-icon left> mdi-plus </v-icon>
        이미지 소재추가
      </v-btn>
    </div>
    <div
      class="resource-cont relative white rounded pa-6 pb-8 pr-16"
      v-for="(resource, i) in this.resources"
      :key="i"
    >
      <div class="resource-box relative">
        <!-- 소재명 -->
        <v-form v-model="valid[i]">
          <div class="form-row-1">
            <p class="label">
              소재명
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </p>
            <div class="write-con">
              <v-text-field
                v-model="resource.name"
                label="첨부할 이미지 소재명을 입력해주세요. (한글/영문 20자이내)"
                class="input-custom-2"
                height="40px"
                solo
                :rules="subjectTitleRules"
              ></v-text-field>
            </div>
          </div>
        </v-form>
        <!-- //소재명 -->
        <!-- 예약설정 -->
        <div class="form-row-1 mb-8">
          <p class="label">
            예약설정
            <span class="required">
              <v-icon>mdi-check-circle-outline</v-icon>
              필수
            </span>
          </p>
          <div class="write-con">
            <div class="datepicker-type-1">
              <v-icon>mdi-calendar-blank</v-icon>
              <date-range-picker
                ref="picker"
                v-model="resource.dateRange"
                :date-format="dateFormat"
                :locale-data="localeData"
                :ranges="false"
                :time-picker="true"
                :time-picker-seconds="true"
                :time-picker-increment="1"
                opens="right"
                @update="updateDateRange(resource)"
              >
                <template v-slot:input="picker" style="min-width: 350px">
                  {{ picker.startDate | moment('YYYY.MM.DD HH:mm:ss') }}
                  <span class="ml-3 mr-3"> ~ </span>
                  {{ picker.endDate | moment('YYYY.MM.DD HH:mm:ss') }}
                </template>
              </date-range-picker>
            </div>
          </div>
        </div>
        <!--// 예약설정 -->
        <!-- 파일업로드 -->
        <div class="form-row-1 mb-8">
          <p class="label">
            파일첨부
            <span class="required">
              <v-icon>mdi-check-circle-outline</v-icon>
              필수
            </span>
          </p>
          <div class="write-con">
            <div class="d-flex">
              <!-- 파일첨부 -->
              <div class="file-upload-box-2">
                <!-- reource에 파일이 있으면 보이도록 -->
                <div v-if="resource.file">
                  <div v-if="!file[i].thumb" class="file-thumb">
                    <img :src="resource.file" style="width: 84px" alt="" />
                  </div>
                  <div v-else class="file-thumb">
                    <img :src="file[i].thumb" style="width: 84px" alt="" />
                  </div>
                </div>
                <!-- reource에 파일이 없고 등록할 때 보이도록 -->
                <div v-else class="file-thumb">
                  <img v-if="file[i].thumb" :src="file[i].thumb" alt="" />
                  <v-icon v-else>mdi-image-outline</v-icon>
                </div>
                <div class="file-text">
                  <div class="d-flex">
                    <div class="file-wrap">
                      <v-btn
                        large
                        depressed
                        max-height="32px"
                        color="#fecd06"
                        class="button-type-1"
                        type="file"
                      >
                        파일 업로드
                      </v-btn>
                      <input
                        type="file"
                        @change="onFileChange($event, i)"
                        accept="image/*"
                        :id="`fileUploader${i}`"
                      />
                    </div>
                    <v-btn
                      large
                      depressed
                      max-height="32px"
                      color="#fecd06"
                      class="button-type-1 ml-2"
                      @click.stop="viewHistory(i)"
                    >
                      광고주소재이력
                    </v-btn>
                  </div>
                  <div
                    v-if="
                      propsInventoryType === 'dri' ||
                      propsInventoryType === 'dr_centerbanner'
                    "
                  >
                    <p class="form-coment-1 my-1 mt-3">
                      <v-icon>mdi-alert-circle-outline</v-icon>
                      JPG 형식만 사용 가능합니다.
                    </p>
                  </div>
                  <div v-else>
                    <p class="form-coment-1 my-1 mt-3">
                      <v-icon>mdi-alert-circle-outline</v-icon>
                      PNG 형식만 사용 가능합니다.
                    </p>
                  </div>
                  <div v-if="!resource.file">
                    <p class="file-name mb-0 mt-1" v-if="file[i].name">
                      {{ file[i].name }}
                    </p>
                  </div>
                </div>
              </div>
              <!--// 파일첨부 -->
            </div>
          </div>
        </div>
        <!-- //파일업로드 -->
        <!-- 소재삭제버튼 -->
        <a
          href="javascript:void(0);"
          class="btn-ico-delete"
          @click.stop="openRemoveConfirmPopup(resource, i)"
        >
          <v-icon>mdi-delete</v-icon>
        </a>
        <!--// 소재삭제버튼 -->
        <!-- 소재저장 버튼-->
        <div class="d-flex justify-center">
          <div v-if="!resource.id">
            <v-btn
              large
              depressed
              max-height="32px"
              color="#fecd06"
              class="button-type-1"
              type="button"
              :disabled="!valid[i] || !file[i].thumb"
              @click.prevent="saveResources(resource)"
            >
              저장
            </v-btn>
          </div>
          <div v-else>
            <v-btn
              large
              depressed
              max-height="32px"
              color="#fecd06"
              class="button-type-1"
              type="button"
              :disabled="!valid[i]"
              @click="updateResources(resource)"
            >
              수정
            </v-btn>
          </div>
        </div>
        <!-- //소재저장 버튼 -->
      </div>
      <!-- //resource-box -->
    </div>
    <SystemAlert v-model="confirmSystemAlert">
      <div slot="noti-text">{{ logResult }}</div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click="removeResource"
        >
          확인
        </v-btn>
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fff"
          class="button-type-1 ml-2"
          @click.stop="confirmSystemAlert = false"
        >
          취소
        </v-btn>
      </div>
    </SystemAlert>
    <SystemAlert v-model="showSystemAlert">
      <div slot="noti-text" v-html="logResult"></div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="showSystemAlert = false"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
    <div v-if="showResources">
      <ResourceHistory
        v-model="showResources"
        :propsInventory="propsInventory"
        :propsAdvertiserId="propsAdvertiserId"
        :propsResourceIndex="editItemIndex"
        @historyImgregitst="updateHistoryImg"
      />
    </div>
  </div>
</template>

<script>
import bus from '@/utils/bus';
import SystemAlert from '~@/modal/SystemAlert.vue';
import { addResource, updateResource, deleteResource } from '@/api/campaign';
import { uploadImgPermissions, uploadFile, createUploadForm } from '@/api/etc';
import { toISOFormattedDate } from '@/utils/validation';
import DateRangePicker from 'vue2-daterange-picker';
import ResourceHistory from '~@/modal/ResourceHistoryModal.vue';

function vaildateTitle(title) {
  let result = false;
  if (title.length <= 20) {
    let re = /^[ㄱ-ㅎ|가-힣|a-z|A-Z|0-9|_\-\s]+$/;
    result = re.test(String(title));
  } else {
    result = false;
  }
  return result;
}

export default {
  components: {
    DateRangePicker,
    SystemAlert,
    ResourceHistory,
  },
  props: {
    propsInventoryType: String,
    propsInventoryId: String,
    propsInventory: Object,
    propsLineItemId: String,
    propsLriId: String,
    propsResources: Array,
    propsAdvertiserId: String,
    propsResourceType: String,
  },
  data: () => ({
    valid: [false],
    subjectTitleRules: [
      v => !!v || '소재명을 입력해주세요.',
      v =>
        (v && /^[ㄱ-ㅎ|가-힣|a-z|A-Z|0-9|_\-\s]+$/.test(v)) ||
        '한글/영문 20자 이내로 입력해주세요.',
      v => (v && v.length <= 20) || '한글/영문 20자 이내로 입력해주세요.',
    ],
    localeData: {
      format: `yyyy-mm-dd HH:MM:ss`,
      applyLabel: '확인',
      cancelLabel: '취소',
      separator: '　~　',
    },
    file: [
      {
        img: null,
        name: null,
        thumb: null,
        type: 1,
      },
    ],

    fileCnt: 1,
    fileCategory: 'png',
    permissionInfo: {},
    preFilePath: '',

    defaultResource: {
      dateRange: { startDate: null, endDate: null },
      name: '',
      start_at: null,
      end_at: null,
      is_valid: 'Y',
      type: 1,
      hash: '',
      file: '',
    },
    showSystemAlert: false,
    confirmSystemAlert: false,
    logResult: '',
    editItem: {},
    editItemIndex: null,

    showResources: false,
  }),
  computed: {
    resources: {
      get() {
        (this.propsResources || []).map(resource => {
          let obj = {
            startDate: resource.start_at,
            endDate: resource.end_at,
          };
          resource.dateRange = obj;
        });
        return this.propsResources;
      },
      set(value) {
        this.propsResources = value;
      },
    },

    defaultStartAt() {
      return this.propsInventory.start_at;
    },
    defaultEndAt() {
      return this.propsInventory.end_at;
    },

    isSubjectTitleVaild(name) {
      return vaildateTitle(name);
    },
  },
  methods: {
    dateFormat(classes, date) {
      if (!classes.disabled) {
        if (date < this.$moment(this.propsInventory.start_at)) {
          classes.disabled = true;
        }
        if (date > this.$moment(this.propsInventory.end_at)) {
          classes.disabled = true;
        }
      }
      return classes;
    },
    onFileChange(e, i) {
      const targetFile = e.target.files[0];
      if (
        this.propsInventoryType === 'dri' ||
        this.propsInventoryType === 'dr_centerbanner'
      ) {
        if (targetFile.type === 'image/jpeg') {
          this.file[i].name = targetFile.name;
          this.file[i].thumb = URL.createObjectURL(targetFile);
          this.file[i].img = targetFile;
          this.file[i].type = 1;

          this.fileCategory = 'jpg';
          this.permissionsImg(i);
        } else {
          this.showSystemAlert = true;
          this.logResult = 'JPG형식만 사용 가능 합니다.';
        }
      } else {
        if (targetFile.type === 'image/png') {
          this.file[i].name = targetFile.name;
          this.file[i].thumb = URL.createObjectURL(targetFile);
          this.file[i].img = targetFile;
          this.file[i].type = 1;

          this.fileCategory = 'png';
          this.permissionsImg(i);
        } else {
          this.showSystemAlert = true;
          this.logResult = 'PNG형식만 사용 가능 합니다.';
        }
      }
      //동일 파일 연속 선택 시, change 이벤트가 발생되지 않도록 추가.
      document.getElementById(`fileUploader${i}`).value = '';
    },

    async permissionsImg(i) {
      try {
        const params = {
          cnt: this.fileCnt,
          category: this.fileCategory,
        };
        const { data } = await uploadImgPermissions({ params });
        this.permissionInfo = data.list[0];
        await this.savefileUpload(i);
      } catch (error) {
        console.log(error.response);
      }
    },
    savefileUpload(i) {
      let url = this.permissionInfo.domain;
      this.preFilePath = this.permissionInfo.uploadImagePath;
      const formData = createUploadForm(this.permissionInfo, this.file[i].img);

      this.uploadComplete(url, formData, i);
    },
    async uploadComplete(url, formData, i) {
      try {
        await uploadFile(url, formData);
      } catch (error) {
        console.log(error.response);
      }
    },

    setDetailResourceIfEmpty() {
      if (this.resources.length === 0) {
        this.defaultResource.dateRange.startDate = this.defaultStartAt;
        this.defaultResource.dateRange.endDate = this.defaultEndAt;
        this.defaultResource.start_at = this.defaultStartAt;
        this.defaultResource.end_at = this.defaultEndAt;
        this.resources.push(JSON.parse(JSON.stringify(this.defaultResource)));
      }
    },

    async saveResources(resource) {
      if (!this.propsLriId) {
        this.showSystemAlert = true;
        this.logResult = '그룹코드를 선택해주세요.';
      } else {
        const campaignId = this.$route.params.id;
        const inventoryId = this.propsInventoryId;
        const lineItemId = this.propsLineItemId;
        const lriId = this.propsLriId;

        resource.start_at = toISOFormattedDate(new Date(resource.start_at));
        resource.end_at = toISOFormattedDate(new Date(resource.end_at));
        resource.name = resource.name.trim();
        resource.file = this.preFilePath;

        try {
          const { data } = await addResource(
            campaignId,
            inventoryId,
            lineItemId,
            lriId,
            resource,
          );
          if (data.result === 'success') {
            const emitData = {
              resourceId: data.value,
              lriId: this.propsLriId,
            };
            this.$emit('getResourceAfterAdd', emitData);
            this.logResult = '저장되었습니다.';
            this.showSystemAlert = true;
          }
        } catch (error) {
          console.log(error.response);
          const { data } = error.response;
          if (data.result === 'OutRange') {
            this.showSystemAlert = true;
            this.logResult =
              '소재의 시작/종료는 지면의 시작, 종료일 범위 내에서만 설정 가능합니다.';
          } else if (data.result === 'IsAlreadyReserved') {
            this.showSystemAlert = true;
            this.logResult = '선택된 지면은 현재 집행중인 캠페인이 있습니다.';
          } else {
            return false;
          }
        }
      }
    },

    async updateResources(resource) {
      const campaignId = this.$route.params.id;
      const inventoryId = this.propsInventoryId;
      const lineItemId = this.propsLineItemId;
      const lriId = this.propsLriId;
      const resourceId = resource.id;

      let updateResourceFile = '';
      if (this.preFilePath && resource.file !== this.preFilePath) {
        updateResourceFile = this.preFilePath;
      } else {
        updateResourceFile = resource.file;
      }

      const resourceData = {
        type: 1,
        name: resource.name.trim(),
        start_at: toISOFormattedDate(new Date(resource.start_at)),
        end_at: toISOFormattedDate(new Date(resource.end_at)),
        file: updateResourceFile,
        hash: resource.hash,
      };
      try {
        const { data } = await updateResource(
          campaignId,
          inventoryId,
          lineItemId,
          lriId,
          resourceId,
          resourceData,
        );

        if (data.result === 'success') {
          const emitData = {
            resourceId: resourceId,
            lriId: this.propsLriId,
          };
          this.$emit('getResourceAfterAdd', emitData);
          this.logResult = '수정되었습니다.';
          this.showSystemAlert = true;
        }
      } catch (error) {
        console.log(error.response);
        const { data } = error.response;
        if (data.result === 'OutRange') {
          this.showSystemAlert = true;
          this.logResult =
            '소재의 시작/종료는 지면의 시작, 종료일 범위 내에서만 설정 가능합니다.';
        }
      }
    },

    updateDateRange(resource) {
      resource.start_at = resource.dateRange.startDate;
      resource.end_at = resource.dateRange.endDate;
    },
    openRemoveConfirmPopup(item, i) {
      if (!item.id) {
        if (this.resources.length > 1) {
          this.resources.splice(i, 1);
          this.valid.splice(i, 1);
        } else {
          return false;
        }
      } else {
        this.editItem = item;
        this.editItemIndex = i;
        this.logResult = '정말로 삭제하시겠습니까?';
        this.confirmSystemAlert = true;
      }
    },
    async removeResource() {
      bus.$emit('start:spinner');
      this.confirmSystemAlert = false;
      try {
        const campaignId = this.$route.params.id;
        const inventoryId = this.propsInventoryId;
        const lineItemId = this.propsLineItemId;
        const lriId = this.propsLriId;
        const resourceId = this.editItem.id;
        const { data } = await deleteResource(
          campaignId,
          inventoryId,
          lineItemId,
          lriId,
          resourceId,
        );

        if (data.result === 'success') {
          //validation check 순번 삭제
          this.valid.splice(this.editItemIndex, 1);

          this.file[this.editItemIndex].name = null;
          this.file[this.editItemIndex].thumb = null;
          this.file[this.editItemIndex].img = null;
          this.file[this.editItemIndex].type = 1;

          //this.file.splice(this.editItemIndex, 1);

          this.logResult = '삭제되었습니다.';
          this.showSystemAlert = true;
          const emitData = {
            resourceId: resourceId,
            lriId: this.propsLriId,
          };
          this.$emit('getResourceAfterDelete', emitData);
        }
        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
      }
    },

    appendResource() {
      //validate check 추가
      this.valid.push(false);

      this.file.push({
        img: null,
        name: null,
        thumb: null,
        type: 1,
      });

      this.defaultResource.dateRange.startDate = this.defaultStartAt;
      this.defaultResource.dateRange.endDate = this.defaultEndAt;
      this.defaultResource.start_at = this.defaultStartAt;
      this.defaultResource.end_at = this.defaultEndAt;
      this.resources.push(JSON.parse(JSON.stringify(this.defaultResource)));
    },
    viewHistory(i) {
      this.showResources = true;
      this.editItemIndex = i;
    },
    updateHistoryImg(data) {
      if (data !== null) {
        this.preFilePath = data.file;
        this.file[this.editItemIndex] = {
          thumb: data.file,
        };
      }
    },
  },
  created() {
    this.setDetailResourceIfEmpty();
    if (this.file.length !== this.resources.length) {
      this.file = [];
      for (let i = 0; i < this.resources.length; i++) {
        this.file.push({
          img: null,
          name: null,
          thumb: null,
          type: 1,
        });
      }
    }
  },
  mounted() {},
  beforeUpdate() {
    if (this.file.length !== this.resources.length) {
      this.file = [];
      for (let i = 0; i < this.resources.length; i++) {
        this.file.push({
          img: null,
          name: null,
          thumb: null,
          type: 1,
        });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.score-banner-gap {
  .resource-cont {
    padding-left: 118px !important;
    padding-right: 0px !important;
    padding-top: 0px !important;
  }
  .btn-resource-add {
    position: absolute;
    top: -64px;
    right: 0;
    z-index: 1;
  }
}
.ingame-aboard-gap {
  .resource-cont {
    padding-left: 118px !important;
    padding-right: 0px !important;
    padding-top: 0px !important;
  }
  .btn-resource-add {
    position: absolute;
    top: -64px;
    right: 0;
    z-index: 1;
  }
}
.ingame-aboard-gap {
  .resource-cont {
    padding-left: 118px !important;
    padding-right: 0px !important;
    padding-top: 0px !important;
  }
  .btn-resource-add {
    position: absolute;
    top: -64px;
    right: 0;
    z-index: 1;
  }
}
.ingame-tmarker-gap {
  .resource-cont {
    padding-left: 118px !important;
    padding-right: 0px !important;
    padding-top: 0px !important;
  }
  .btn-resource-add {
    position: absolute;
    top: -64px;
    right: 0;
    z-index: 1;
  }
}
.ingame-flag-gap {
  .resource-cont {
    padding-left: 118px !important;
    padding-right: 0px !important;
    padding-top: 0px !important;
  }
  .btn-resource-add {
    position: absolute;
    top: -64px;
    right: 0;
    z-index: 1;
  }
}

.ingame-flat-gap {
  .resource-cont {
    padding-left: 118px !important;
    padding-right: 0px !important;
    padding-top: 0px !important;
  }
  .btn-resource-add {
    position: absolute;
    top: -64px;
    right: 0;
    z-index: 1;
  }
}

.both-type {
  .resource-cont {
    padding-top: 0 !important;
  }
  .btn-resource-add {
    margin-top: 0 !important;
    padding-top: 0px !important;
    padding-bottom: 0 !important;
    position: absolute;
    top: -128px;
    right: 0;
    z-index: 1;
  }
}

.resource-cont {
  margin-top: 12px;
}
.btn-resource-add {
  position: absolute;
  right: 0;
  top: -44px;
}
</style>
